(function(){
  function toNum(el){
    if(!el) return null;
    var m=(el.textContent||'').replace(/[^0-9.,]/g,'').replace(/,/g,'');
    var n=parseFloat(m);
    return isNaN(n)?null:n;
  }
  function run(){
    var cards=document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    cards.forEach(function(card){
      if(card.getAttribute('data-dsard-badge')==='1') return;
      var priceEl=card.querySelector('.price--on-sale');
      if(!priceEl) return;
      var sale=toNum(priceEl.querySelector('.price__sale .price-item--sale')||priceEl.querySelector('.price-item--sale'));
      var reg=toNum(priceEl.querySelector('.price__sale .price-item--regular')||priceEl.querySelector('.price-item--regular'));
      if(!sale||!reg||reg<=sale) return;
      var pct=Math.round((reg-sale)/reg*100);
      var label='−'+pct+'%';
      var natives=card.querySelectorAll('[id^="Badge-"], [id^="NoMediaStandardBadge-"]');
      natives.forEach(function(nb){
        if(/sale/i.test(nb.textContent)){
          nb.textContent=label;
          nb.classList.add('dsard-badge');
        }
      });
      card.setAttribute('data-dsard-badge','1');
    });
  }
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  document.addEventListener('shopify:section:load',run);
})();
